<template>
  <div>
    <div v-for="item of items" :key="`cost-result-${item.id}`" class="mb-1">
      <div class="rounded p-0" :class="serviceRowStyles(item)">
        <div
          class="row mx-auto"
          :class="{
            'd-flex align-items-center': !isMobile,
          }"
        >
          <div
            :class="{
              'col-2 px-4 py-2': !isMobile,
              'col py-2': isMobile,
            }"
          >
            <p class="color-gray font-14 mb-0 pl-2">Servicio:</p>
            <p
              class="color-black font-16 mb-0 pl-2"
              :class="
                isServiceDisabled(item) && !isReadOnly
                  ? 'color-secondary-7'
                  : 'color-black'
              "
            >
              {{ item.serviceName }}
            </p>
          </div>
          <div
            :class="{
              'col-1 row mx-auto px-5 py-2': !isMobile,
              'col py-2': isMobile,
            }"
          >
            <div :class="{ 'col-6': !isMobile }">
              <p class="color-gray font-14 mb-0">Costo:</p>
              <p
                class="font-16 mb-0"
                :class="
                  isServiceDisabled(item) && !isReadOnly
                    ? 'color-secondary-7'
                    : 'color-black'
                "
              >
                {{ item.cost | money }}
              </p>
            </div>
          </div>
          <div
            v-if="
              showCostAdjustment ||
                (isReadOnly && item.isPaidAmountLessThanApprovedFlag !== null)
            "
            :class="{
              'col-3 row mx-auto px-5 py-2': !isMobile,
              'col py-2': isMobile,
            }"
          >
            <div :class="{ col: !isMobile }">
              <p class="color-gray font-14 mb-0">
                ¿El monto pagado es menor a aprobado?
              </p>
              <div class="d-flex align-items-center mt-1">
                <b-form-radio
                  v-model="item.isPaidAmountLessThanApprovedFlag"
                  :disabled="isReadOnly || !item.checked"
                  :name="`adj-${item.id}`"
                  :value="true"
                  @change="onAdjustmentFlagChange(item, true)"
                >
                  Sí
                </b-form-radio>
                <b-form-radio
                  v-model="item.isPaidAmountLessThanApprovedFlag"
                  class="ml-3"
                  :disabled="isReadOnly || !item.checked"
                  :name="`adj-${item.id}`"
                  :value="false"
                  @change="onAdjustmentFlagChange(item, false)"
                >
                  No
                </b-form-radio>
              </div>
            </div>
          </div>
          <div
            v-if="isTherapyService(item) && item.checked"
            :class="{
              'col-2 row mx-auto px-5 py-2': !isMobile,
              'col py-2': isMobile,
            }"
          >
            <div :class="{ col: !isMobile }">
              <p class="color-gray font-14 mb-0">Intervenciones:</p>
              <p
                class="font-16 mb-0"
                :class="
                  isServiceDisabled(item) && !isReadOnly
                    ? 'color-secondary-7'
                    : 'color-black'
                "
              >
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|min_value:1"
                >
                  <custom-input
                    v-if="!readOnly"
                    :value="item.visitCount"
                    @input="onVisitCountChange(item, $event)"
                    custom-error-msg="La cantidad de intervenciones es requerida."
                    type="number"
                    :error="errors[0]"
                  />
                </validation-provider>
                <span v-if="readOnly">{{ item.visitCount }}</span>
              </p>
            </div>
          </div>
          <div
            v-if="
              item.isPaidAmountLessThanApprovedFlag === true &&
                ((showCostAdjustment && item.checked) || isReadOnly)
            "
            :class="{
              'col-2 row mx-auto px-5 py-2': !isMobile,
              'col py-2': isMobile,
            }"
          >
            <div :class="{ col: !isMobile }">
              <p class="color-gray font-14 mb-0">Monto:</p>
              <custom-input
                v-if="!readOnly"
                type="number"
                :value="item.costAdjustment"
                @input="onCostAdjustmentChange(item, $event)"
              />
              <span v-else class="font-16">
                {{ item.costAdjustment | money }}
              </span>
            </div>
          </div>

          <div
            v-if="isTherapyService(item) && item.checked"
            :class="{
              'col-1 row mx-auto px-5 py-2': !isMobile,
              'col py-2': isMobile,
            }"
          >
            <div :class="{ col: !isMobile }">
              <p class="color-gray font-14 mb-0">Costo Total:</p>
              <p
                class="font-16 mb-0"
                :class="
                  isServiceDisabled(item) && !isReadOnly
                    ? 'color-secondary-7'
                    : 'color-black'
                "
              >
                {{ getRowTotal(item) | money }}
              </p>
            </div>
          </div>

          <div
            v-if="isTherapyService(item) && item.checked"
            :class="{
              'col row mx-auto px-5 py-2': !isMobile,
              'col py-2': isMobile,
            }"
          >
            <div :class="{ col: !isMobile }">
              <p class="color-gray font-14 mb-0">Certificación de Servicios:</p>
              <p
                class="font-16 mb-0"
                :class="
                  isServiceDisabled(item) && !isReadOnly
                    ? 'color-secondary-7'
                    : 'color-black'
                "
              >
                <validation-provider
                  v-if="!item.document"
                  v-slot="{ validate, errors }"
                  rules="required"
                >
                  <custom-file-input
                    v-if="!item.document"
                    ref="fileUpload"
                    accept=".pdf"
                    class="custom-document-input"
                    custom-error-msg="Por favor incluya un archivo documentando las intervenciones ocurridas."
                    display-style="normal"
                    :error="errors[0]"
                    label=""
                    :on-download="() => {}"
                    required
                    @after-remove="onServiceFileRemoved(item)"
                    @input="
                      onServiceFileChange(item, $event) || validate($event)
                    "
                  />
                </validation-provider>
                <action-button
                  v-if="item.document"
                  i="fas fa-download"
                  text="Descargar"
                  variant="success download-btn px-3"
                  @click="onDownload(item.document.documentId)"
                />
                <action-button
                  v-if="item.document && !readOnly"
                  i="fas fa-undo-alt"
                  text="Reemplazar"
                  variant="outline-success download-btn ml-3"
                  @click="onReplaceDocument(item)"
                />
              </p>
            </div>
          </div>
          <div
            v-if="
              !isTherapyService(item) &&
                item.isPaidAmountLessThanApprovedFlag !== null &&
                ((showCostAdjustment && item.checked) || isReadOnly)
            "
            :class="{
              'col-2 row mx-auto px-5 py-2': !isMobile,
              'col py-2': isMobile,
            }"
          >
            <div :class="{ col: !isMobile }">
              <p class="color-gray font-14 mb-0">Costo Total:</p>
              <p class="font-16 mb-0 color-black">
                {{ getRowTotal(item) | money }}
              </p>
            </div>
          </div>

          <div
            v-if="!isReadOnly"
            class="check-box"
            :class="checkboxStyles(item)"
          >
            <check-box
              class="d-flex justify-content-center align-items-center p-0"
              :class="checkboxStyles(item)"
              :disabled="isServiceDisabled(item)"
              v-model="item.checked"
              @input="
                onSelectService({
                  serviceId: item.serviceId,
                  checked: $event,
                  cost: item.cost,
                  visitCount: item.visitCount,
                  file: item.file,
                  tapCentralServiceId: item.id,
                  serviceCategoryId: item.serviceCategoryId,
                  tapRequestId: item.requestId,
                  isPaidAmountLessThanApprovedFlag:
                    item.isPaidAmountLessThanApprovedFlag,
                  costAdjustment: item.costAdjustment,
                })
              "
            />
          </div>
        </div>
      </div>
      <custom-error
        v-if="adjustmentError(item)"
        class="mt-n1"
        :is-alert-mode="true"
        :message="adjustmentError(item)"
      />
    </div>
    <div
      v-if="!isReadOnly"
      class="service-total rounded bg-secondary-12 d-flex justify-content-end align-items-center px-3 py-2 mt-2"
    >
      <span class="color-black font-16">
        Monto Solicitado para Reembolso en el(los) periodo(s) seleccionado(s):
      </span>
      <span class="color-black font-16 font-weight-bold pl-2">
        {{ totalAmount | money }}
      </span>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CheckBox from 'CheckBox';
import CustomInput from 'CustomInput';
import CustomFileInput from 'CustomFileInput';
import CustomError from 'custom-error';
import documentService from '@/services/documents';

export default {
  name: 'RequestServices',
  components: {
    ActionButton,
    CheckBox,
    CustomInput,
    CustomFileInput,
    CustomError,
  },
  filters: {
    money(value) {
      return '$' + (Math.round(value * 100) / 100).toFixed(2);
    },
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: [String, Boolean],
      default: () => '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    showCostAdjustment: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.selectedItems.forEach((e) => {
      this.onSelectService({
        id: e.id,
        tapCentralServiceId: e.tapCentralServiceId,
        serviceId: e.serviceId,
        checked: true,
        cost: e.cost,
        visitCount: e.visitCount,
        file: null,
        document: e.document,
        serviceCategoryId: e.serviceCategoryId,
        isPaidAmountLessThanApprovedFlag:
          e.isPaidAmountLessThanApprovedFlag ?? null,
        costAdjustment: e.costAdjustment ?? null,
      });
      let item = this.items.find((i) => i.id == e.tapCentralServiceId);
      item.visitCount = e.visitCount;
      item.document = e.document;
      item.checked = true;
      item.isPaidAmountLessThanApprovedFlag =
        e.isPaidAmountLessThanApprovedFlag ?? null;
      item.costAdjustment = e.costAdjustment ?? null;
    });
  },
  data() {
    return {
      selectedServices: [],
    };
  },
  computed: {
    isReadOnly() {
      return this.readOnly;
    },
    totalAmount() {
      const total = this.selectedServices.reduce(
        (sum, x) => sum + this.getRowTotal(x),
        0
      );
      this.$emit('update-amount', total);
      return total;
    },
    isServiceDisabled() {
      return (item) => {
        return this.items.some((x) => x.id === item.id && !x.isBillable);
      };
    },
    serviceRowStyles() {
      return (item) => {
        const isBlocked = this.isServiceDisabled(item);
        let styles = '';

        if (isBlocked && !this.isReadOnly) {
          styles += ' bg-secondary-11';
        } else {
          styles += ' bg-white';
        }

        if (!this.isReadOnly) {
          styles += ' service-option-border';
        }

        return styles;
      };
    },
    checkboxStyles() {
      return (item) => {
        const isDisabled = this.isServiceDisabled(item);
        const isChecked = this.selectedServices.find(
          (x) => x.id === item.id && x.checked
        );
        let styles = '';

        if (isChecked) {
          styles += ' bg-gray-14';
        }
        if (isDisabled) {
          styles += ' disabled-check';
        }
        if (!this.isMobile) {
          styles += ' py-3 px-4';
        } else {
          styles += ' px-2';
        }

        return styles;
      };
    },
  },
  watch: {
    selectedServices() {
      this.$emit('on-select-services', this.selectedServices);
    },
  },
  methods: {
    adjustmentError(item) {
      if (
        this.showCostAdjustment &&
        item.checked &&
        item.isPaidAmountLessThanApprovedFlag === true &&
        item.costAdjustment &&
        this.isAdjustmentInvalid(item)
      ) {
        return 'El ajuste del costo debe ser menor al costo acordado.';
      }
      return null;
    },
    getRowTotal(serviceItem) {
      const cost = Number(serviceItem.cost ?? 0);
      const hasValidAdjustment =
        (this.showCostAdjustment || this.isReadOnly) &&
        serviceItem.isPaidAmountLessThanApprovedFlag === true &&
        Number(serviceItem.costAdjustment) > 0 &&
        Number(serviceItem.costAdjustment) < cost;

      if (hasValidAdjustment) {
        return Number(serviceItem.costAdjustment);
      }

      if (this.isTherapyService(serviceItem)) {
        return cost * Number(serviceItem.visitCount ?? 0);
      }
      return cost;
    },
    isAdjustmentInvalid(item) {
      return (
        !item.costAdjustment ||
        Number(item.costAdjustment) <= 0 ||
        Number(item.costAdjustment) >= Number(item.cost)
      );
    },
    onAdjustmentFlagChange(item, value) {
      item.isPaidAmountLessThanApprovedFlag = value;
      if (!value) item.costAdjustment = null;
      const selectedService = this.selectedServices.find(
        (s) => s.tapCentralServiceId == item.id
      );
      if (selectedService) {
        selectedService.isPaidAmountLessThanApprovedFlag = value;
        selectedService.costAdjustment = item.costAdjustment;
        this.$emit('on-select-services', this.selectedServices);
      }
    },
    onCostAdjustmentChange(item, value) {
      const parsed = parseFloat(value) || null;
      item.costAdjustment = parsed;
      const selectedService = this.selectedServices.find(
        (s) => s.tapCentralServiceId == item.id
      );
      if (selectedService) {
        selectedService.costAdjustment = parsed;
        this.$emit('on-select-services', this.selectedServices);
      }
    },
    onReplaceDocument(item) {
      this.removeDocumentData(item);
    },
    onServiceFileRemoved(item) {
      this.removeDocumentData(item);
    },
    removeDocumentData(item) {
      item.document = null;
      let selectedService = this.selectedServices.find(
        (s) => s.tapCentralServiceId == item.id
      );
      selectedService.file = null;
      selectedService.document = null;
      this.$emit('on-select-services', this.selectedServices);
    },
    onServiceFileChange(item, file) {
      let selectedService = this.selectedServices.find(
        (s) => s.tapCentralServiceId == item.id
      );
      selectedService.file = file;
      this.$emit('on-select-services', this.selectedServices);
    },
    onVisitCountChange(item, event) {
      let selectedService = this.selectedServices.find(
        (s) => s.tapCentralServiceId == item.id
      );
      item.visitCount = parseInt(event);
      selectedService.visitCount = parseInt(event);
      this.$emit('on-select-services', this.selectedServices);
    },
    async onDownload(documentId) {
      await documentService.downloadFromServer(documentId);
    },
    onSelectService(selection) {
      const isSelected = this.selectedServices.some(
        (x) => x.tapCentralServiceId === selection.tapCentralServiceId
      );

      if (selection.checked && !isSelected) {
        this.selectedServices.push({ ...selection });
      } else if (!selection.checked && isSelected) {
        this.selectedServices = this.selectedServices.filter(
          (x) => x.tapCentralServiceId !== selection.tapCentralServiceId
        );
        const item = this.items.find(
          (x) => x.id === selection.tapCentralServiceId
        );
        if (item) {
          item.isPaidAmountLessThanApprovedFlag = null;
          item.costAdjustment = null;
        }
      }
    },
    isTherapyService(item) {
      return item.serviceCategoryId == 2;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/scss/variables/colors.scss';

.service-option-border {
  border: 1px solid map-get($colors, 'gray-13');
}
.check-box {
  display: flex;
  justify-content: end;
  align-items: center;
  border-left: 1px solid map-get($colors, 'gray-13');
}
::v-deep .input-group .option-input + label span {
  margin: 0 !important;
}
::v-deep .disabled-check .input-group .option-input + label span {
  margin: 0 !important;
  background-color: map-get($colors, 'secondary-5') !important;
}
</style>
